import { AbacoVuexModule, State } from '@abaco/web-common/src/app';
import { Crop } from "./models/SCSModels";
import { FilterPlot, Plot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";

export default class SupplyChainVuexModule extends AbacoVuexModule
{
    @State() cultureSelectionNavBarItemOpen!: boolean;

    @State() curCulture!: Crop | null;

    @State({default: {rotation: 1}}) crossFilters!: FilterPlot;

    @State() proseccoFromMapToTable!: number[];
    @State() proseccoFromTableToMap!: number[];

    @State() scsMapClickPoint!: number[];

    @State({default: false}) loadingPlots!: boolean;
    @State({default: []}) scPlots!: Plot[];
    @State({default: false}) plotHasValidityDate!: boolean;
}
